module.exports = __webpack_public_path__ + "static/media/login-logo.302e2f07.png";